import React, {useEffect, useState} from 'react';
import {motion} from "framer-motion";
import s from './TransferDataPreview.module.css'
import {ReactComponent as Back} from '../../../../assets/img/personalAccount/back.svg'
import Icon from "@ant-design/icons";
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux";
import {PrepareDataForBankTransaction} from "../../../../helpers/prepareDataForTransactions/PrepareDataForTranzactions";
import {createTemplate, SendTransferThunk} from "../../../../store/reducers/ActionCreators";
import {setDisabled, setIsLoading} from "../../../../store/reducers/UserSlice";
import CustomModal from "../../../../components/ui/CustomModal/CustomModal";
import MyBtn from "../../../../components/ui/MyBtn/MyBtn";
import TransparentButton from "../../../../components/ui/TransparentButton/TransparentButton";
import PopUpTwoFaCodConfirm from "../../../../components/ui/PopUpTwoFaCodConfirm/PopUpTwoFaCodConfirm";
import {getWithdrawalCode, transferDataPreview} from "../../../../store/reducers/TransactionsSlice/selector";
import {useNavigate} from "react-router-dom";
import {setTransferDataPreview} from "../../../../store/reducers/TransactionsSlice/TransactionsSlice";
import {PrepareDataForLuxpayTransaction} from "../../../../helpers/PrepareDataForLuxpayTransaction";

const TransferDataPreview = () => {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const token = useAppSelector(state => state.userReducer.userToken)
    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState<boolean | null>(false)
    const [isErrorPopupOpen, setIsErrorPopupOpen] = useState<boolean | null>(false)
    const [isTooManyAttempts, setIsTooManyAttempts] = useState<boolean | null>(false)
    const [errorText, setErrorText] = useState('')
    const [showModalVerfyTransfer, setIsShowVerifyModalTransfer] = useState<boolean | null>(false)
    const withdrawalCode = useAppSelector(getWithdrawalCode)

    const dataPreview = useAppSelector(transferDataPreview)

    const toReadableFormat = (str: string) => {
        return str
            .replace(/([A-Z])/g, ' $1')
            .trim() // Убираем лишние пробелы
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const getPinTwoFa = (twoFaCode: string) => {
        sendTransferData(twoFaCode)
    }

    const closeErrorModal = () => {
        if (isTooManyAttempts) {
            setIsErrorPopupOpen(false)
            sessionStorage.removeItem("transfer-form")
            setErrorText('')
            navigate(-1)
        }
        setIsErrorPopupOpen(false)
        setErrorText('')
    }

    useEffect(() => {
        dispatch(setIsLoading(false))
    }, []);

    const closeAndRedirect = () => {
        setIsSuccessPopupOpen(false)
        sessionStorage.removeItem("transfer-form")
        navigate('/personal-account/accounts')
    }

    const closeEmailPinPopUp = () => {
        setIsErrorPopupOpen(false)
        setErrorText('')
        setIsShowVerifyModalTransfer(false)
    }

    const sendTransferData = async (twoFaCode: string) => {
        dispatch(setDisabled(true))

        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let preparedData;

        if (dataPreview.type === 'sepa' || dataPreview.type === 'international') {
            preparedData = PrepareDataForBankTransaction(dataPreview, withdrawalCode);
        } else {
            preparedData = PrepareDataForLuxpayTransaction(dataPreview, accountId);
        }

        const ResponseObj = {
            challengeId: dataPreview.challengeData.challengeId,
            twoFaCode,
            transaction: {
                ...preparedData,
                userTimezone: timezone
            }
        };

        dispatch(SendTransferThunk(token, ResponseObj, accountId))
            .then((res) => {
                if (res.data === 'Created') {
                    setIsShowVerifyModalTransfer(null)
                    setIsSuccessPopupOpen(true)
                    sessionStorage.removeItem("transfer-form");
                    localStorage.removeItem("transfer-form");
                    dispatch(setTransferDataPreview({}))
                } else {
                    setIsErrorPopupOpen(true)
                }
            })
            .catch((e) => {
                if (e.response.data === "Not enough money to create transaction") {
                    setErrorText('The transfer cannot be made due to insufficient funds.')
                    setIsErrorPopupOpen(true)
                    return
                }

                if (e.response.data === "Invalid 2fa code") {
                    setErrorText('Invalid or expired 2FA code. Please try again')
                    setIsErrorPopupOpen(true)
                } else if (e.response.data === "Challenge is no longer active") {
                    setErrorText('Transaction failed due to too many attempts')
                    setIsTooManyAttempts(true)
                    setIsErrorPopupOpen(true)
                } else {
                    setErrorText('Your request was rejected. Please try again.')
                    setIsErrorPopupOpen(true)
                }
            })
            .finally(() => {
                sessionStorage.removeItem("transfer-form")
                dispatch(setDisabled(false))
            })
    }

    const sendTemplateData = async () => {
        dispatch(setDisabled(true))

        let preparedData;

        if (dataPreview.type === 'sepa' || dataPreview.type === 'international') {
            preparedData = PrepareDataForBankTransaction(dataPreview);
        } else {
            preparedData = PrepareDataForLuxpayTransaction(dataPreview, accountId);
        }

        dispatch(createTemplate(token, preparedData))
            .then((res) => {
                if (res.data === 'Created') {
                    setIsSuccessPopupOpen(true)
                    sessionStorage.removeItem("transfer-form");
                    localStorage.removeItem("transfer-form");
                    dispatch(setTransferDataPreview({}))
                }
            }).catch((e) => {
                setIsErrorPopupOpen(true)
        })
            .finally(() => {
                dispatch(setDisabled(false))
            })
    }

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >

            <CustomModal isNotify isModalOpen={isSuccessPopupOpen} setIsModalOpen={setIsSuccessPopupOpen}>
                <div className={s.modal_content}>
                    <div className={s.popup_subtitle}>
                        <span className={s.success}>Success!</span> Your request has been sent successfully.
                    </div>
                    <div className={s.popup_button_block}>
                        <MyBtn title={'Ok'} isPersonalAccountBtn medium onClick={() => closeAndRedirect()}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal isNotify type="error" isModalOpen={isErrorPopupOpen} setIsModalOpen={setIsErrorPopupOpen}>
                <div className={s.modal_content}>
                    <div className={s.popup_subtitle}>
                        <span
                            className={s.error}>Failed!</span> {errorText}
                    </div>
                    <div className={s.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={closeErrorModal}/>
                    </div>
                </div>
            </CustomModal>

            <div className={s.wrapper}>

                <div className={s.title}>
                    Transfer Information
                </div>
                <div className={s.data_block}>

                    {Object.entries(dataPreview).map(([key, value]) => {

                        if (value !== ""
                            && value !== null
                            && value !== undefined
                            && key !== "hiddenAccountNumberFrom"
                            && key !== "accNumberFrom"
                            && key !== "accNumberTo"
                            && key !== "recipientType"
                            && key !== "paymentRegions"
                            && key !== "payerAccountCurrency"
                            && key !== "transferCurrency"
                            && key !== "accountId"
                            && key !== "amount"
                            && key !== "type"
                            && key !== "fee"
                            && key !== "totalAmount"
                            && key !== "invoice"
                            && key !== "isTemplateCreation"
                            && key !== "achRoutingNumber"
                            && key !== "fullName"
                            && key !== "fedwireRoutingNumber"
                            && key !== "sortCode"
                            && key !== "accountNumber"
                            && key !== "hiddenAccountNumber"
                            && key !== "hiddenAccountNumberTo"
                            && key !== "accNumberFromCurrency"
                            && key !== "emailLanguage"
                            && key !== "tabIndex"
                            && key !== "templateType"
                            && key !== "transferMethod"
                            && key !== "challengeData"
                            && key !== "clientId"

                        ) {
                            return (
                                <div className={s.row} key={key}>
                                    <span className={s.row_name}>{toReadableFormat(key)}</span>
                                    <span className={s.row_value}>{value as any}</span>
                                </div>
                            )
                        }
                        if (["accNumberTo"].includes(key) && dataPreview.transferMethod === 'account' ) {
                            return (
                                <div className={s.row} key={key}>
                                    <span className={s.row_name}>Recipient</span>
                                    <span className={s.row_value}>{value as any}</span>
                                </div>
                            )
                        }
                        if (!dataPreview.isTemplateCreation && ["amount", "fee", "totalAmount"].includes(key)) {
                            return (
                                <div className={s.row} key={key}>
                                    <span className={s.row_name}>{toReadableFormat(key)}</span>
                                    <span className={s.row_value}>{value as any} {dataPreview.transferCurrency}</span>
                                </div>
                            )
                        }
                        if (!dataPreview.isTemplateCreation && key === "invoice") {
                            return (
                                <div className={s.row} key={key}>
                                    <span className={s.row_name}>{toReadableFormat(key)}</span>
                                    <span className={s.row_value}>
                                        {dataPreview.invoice?.name ? (
                                            <>
                                                {dataPreview.invoice?.name}
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </span>
                                </div>
                            );
                        }
                        return null;
                    })}

                </div>

                {dataPreview.isTemplateCreation
                    ? <div className={s.buttons_block}>
                        <div className={s.button_wrapper}>
                            <TransparentButton
                                isPersonalAccountBtn
                                icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                large
                                title={"Back"}
                                onClick={() => navigate(-1)}/>
                        </div>

                        <div className={s.button_wrapper}>
                            <MyBtn large title={'Create'} isPersonalAccountBtn onClick={() => sendTemplateData()}
                                   data-testid="send-transfer-button"/>
                        </div>
                    </div>
                    : <div className={s.buttons_block}>
                        <div className={s.button_wrapper}>
                            <TransparentButton
                                isPersonalAccountBtn
                                icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                large
                                title={"Back"}
                                onClick={() => navigate(-1)}/>
                        </div>

                        <div className={s.button_wrapper}>
                            <MyBtn large title={'Transfer'} isPersonalAccountBtn onClick={() => setIsShowVerifyModalTransfer(true)}
                                   data-testid="send-transfer-button"/>
                            {showModalVerfyTransfer ?
                                <PopUpTwoFaCodConfirm
                                    getPinTwoFa={getPinTwoFa}
                                    onClose={closeEmailPinPopUp}
                                    sendTransferData={sendTransferData}
                                    shortTransferInfo={dataPreview.challengeData}
                                    transferType={dataPreview.type}
                                />
                                :
                                null}
                        </div>
                    </div>
                }

            </div>
        </motion.div>
    );
};

export default TransferDataPreview;
